import '../../node_modules/mapbox-gl/dist/mapbox-gl.css';
import '../../node_modules/wallop/css/wallop.css';
import '../../node_modules/wallop/css/wallop--fade.css';
import '../../node_modules/wallop/css/wallop--slide.css';
import '../../node_modules/@glidejs/glide/dist/css/glide.core.min.css';

window.easings = {};
window.easings.ease = 'cubicBezier(0.25, 0.46, 0.45, 0.94)';
window.easings.andrew = 'cubicBezier(0.77, 0, 0.175, 1)';
window.easings.feebles1 = 'cubicBezier(.8,.03,.25,1)';
window.easings.feebles2 = 'cubicBezier(.72,.01,.25,1)';
window.easings.ease2 = 'cubicBezier(.48,.1,.48,.9)';

if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
}

window.isIe11 = function() {
  return !!navigator.userAgent.match(/Trident.*rv\:11\./);
};

window.isIOS = function() {
  var iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];

  if (!!navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }
  }

  return false;
};

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function() {
  this.value = window
    .getComputedStyle(document.querySelector('body'), ':before')
    .getPropertyValue('content')
    .replace(/\"/g, '');
};

$(window)
  .resize(function() {
    Breakpoint.refreshValue();
  })
  .resize();


// Libs
import PubSub from 'underpub-js';
// N'exposer PubSub que si on est sur l'environnement de développement local
if (window.location.hostname === 'js-held.ddev.site' || window.location.hostname === 'localhost') {
  window.PubSub = PubSub; 
}
import Sitewide from './classes/Sitewide';
import ComponentsLoader from './classes/ComponentsLoader';
import './classes/GooglePlaceField.js';
import './classes/promise-polyfill.js';


// Components
import Header from '../components/molecules/global/Header/Header';
import MobileNav from '../components/molecules/global/MobileNav/MobileNav';
import MenuItemSecondary from '../components/elements/global/Header/MenuItemSecondary/MenuItemSecondary';
import MenuItemWithSubmenu from '../components/elements/global/Header/MenuItemWithSubmenu/MenuItemWithSubmenu';
import Hamburger from '../components/elements/global/Header/Hamburger/Hamburger';
import SubnavComplex from '../components/elements/global/Header/SubnavComplex/SubnavComplex';
import Hero from '../components/molecules/misc/Hero/Hero';
import OverlayDark from '../components/elements/OverlayDark/OverlayDark';
import NavSelector from '../components/elements/NavSelector/NavSelector';
import NavBar from '../components/molecules/navandmenu/NavBar/NavBar';
import NavMenu from '../components/molecules/navandmenu/NavMenu/NavMenu';
import MobileNavOverlay from '../components/molecules/navandmenu/MobileNavOverlay/MobileNavOverlay';
import MobileSubnav from '../components/molecules/navandmenu/MobileSubnav/MobileSubnav';
import CaseStudies from '../components/molecules/listings/CaseStudies/CaseStudies';
import Footer from '../components/molecules/footer/Footer/Footer';
import FooterCta from '../components/molecules/footer/FooterCta/FooterCta';
import SelectorImageGallery from '../components/molecules/selectors/SelectorImageGallery/SelectorImageGallery';
import IconCardsBig from '../components/molecules/iconcards/IconCardsBig/IconCardsBig';
import InlineMap from '../components/molecules/content/InlineMap/InlineMap';
import ComponentsStage from '../components/stage/ComponentsStage/ComponentsStage';
import FilterWithIcons from '../components/elements/FilterWithIcons/FilterWithIcons';
import FilterWithoutIcons from '../components/elements/FilterWithoutIcons/FilterWithoutIcons';
import Directory from '../components/molecules/misc/Directory/Directory.js';
import DirectoryTwo from '../components/molecules/misc/DirectoryTwo/DirectoryTwo.js';
import JobListing from '../components/molecules/misc/JobListing/JobListing.js';
import Alert from '../components/molecules/misc/Alert/Alert';
import GlobalAlert from '../components/molecules/misc/GlobalAlert/GlobalAlert.js';
import Timeline from '../components/molecules/misc/Timeline/Timeline';
import Sharing from '../components/elements/Sharing/Sharing';
import VideoOverlay from '../components/elements/VideoOverlay/VideoOverlay';
import Selector from '../components/molecules/selectors/Selector/Selector';
import FormBasic from '../components/molecules/forms/FormBasic/FormBasic';
import FormFullWidth from '../components/molecules/forms/FormFullWidth/FormFullWidth';
import FormWithSidebar from '../components/molecules/forms/FormWithSidebar/FormWithSidebar';
import GatedDocument from '../components/molecules/forms/GatedDocument/GatedDocument';
import GatedContent from '../components/molecules/forms/GatedContent/GatedContent';
import SubmitAssignment from '../components/molecules/forms/SubmitAssignment/SubmitAssignment';
import QuoteCards from '../components/molecules/misc/QuoteCards/QuoteCards';
import DirectoryWidget from '../components/elements/DirectoryWidget/DirectoryWidget';
import FormFieldText from '../components/elements/FormFieldText/FormFieldText';
import FormFieldDropdown from '../components/elements/FormFieldDropdown/FormFieldDropdown';
import FormFieldNumber from '../components/elements/FormFieldNumber/FormFieldNumber';
import FormFieldPhone from '../components/elements/FormFieldPhone/FormFieldPhone';
import FormFieldFileUpload from '../components/elements/FormFieldFileUpload/FormFieldFileUpload';
import FormFieldAddress from '../components/elements/FormFieldAddress/FormFieldAddress';
import LanguageSelectorModal from '../components/molecules/misc/LanguageSelectorModal/LanguageSelectorModal';
import VideoCard from '../components/elements/VideoCard/VideoCard';
import VideoModal from '../components/molecules/misc/VideoModal/VideoModal';
import ExpertiseListingWithChildren from '../components/molecules/listings/ExpertiseListingWithChildren/ExpertiseListingWithChildren';
import ExpertiseListingWithCallout from '../components/molecules/listings/ExpertiseListingWithCallout/ExpertiseListingWithCallout';
import QuoteSlider from '../components/molecules/misc/QuoteSlider/QuoteSlider';
import Offices from '../components/molecules/misc/Offices/Offices.js';
import ContentImageSlider from '../components/molecules/content/ContentImageSlider/ContentImageSlider';
import ImageSlider from '../components/molecules/content/ImageSlider/ImageSlider';
import Bio from '../components/molecules/misc/Bio/Bio.js';
import FileDownload from '../components/atoms/FileDownload/FileDownload.js';

import InsightsSlider from '../components/molecules/listings/InsightsSlider/InsightsSlider.js';
import FeaturedEventsSlider from '../components/molecules/listings/FeaturedEventsSlider/FeaturedEventsSlider.js';
import InsightsEventsHighlightSlider from '../components/molecules/listings/InsightsEventsHighlightSlider/InsightsEventsHighlightSlider.js';
import InsightListingsWithFilters from '../components/molecules/listings/InsightListingsWithFilters/InsightListingsWithFilters.js';
import EventListingsWithFilters from '../components/molecules/listings/EventListingsWithFilters/EventListingsWithFilters.js';
import KeyContactsSlider from '../components/molecules/listings/ExpertiseKeyContacts/KeyContacts.js';

import IconCardBig from '../components/elements/IconCardBig/IconCardBig';
import IconCard from '../components/elements/IconCard/IconCard';

$(document).ready(function() {
  var components = [
    { handle: '.comp-Header', require: Header },
    { handle: '.comp-QuoteSlider', require: QuoteSlider },
	  { handle: '.comp-ContentImageSlider', require: ContentImageSlider },
    { handle: '[data-image-slider]', require: ImageSlider },
    { handle: '.comp-MobileNav', require: MobileNav },
    { handle: '.el-MenuItemSecondary', require: MenuItemSecondary },
    { handle: '.el-MenuItemWithSubmenu', require: MenuItemWithSubmenu },
    { handle: '.el-Hamburger', require: Hamburger },
    { handle: '.el-SubnavComplex', require: SubnavComplex },
    { handle: '[data-hero]', require: Hero },
    { handle: '[data-nav-bar]', require: NavBar },
    { handle: '[data-nav-menu]', require: NavMenu },
    { handle: '[data-mobile-nav-overlay]', require: MobileNavOverlay },
    { handle: '[data-mobile-subnav]', require: MobileSubnav },
    { handle: '[data-case-studies]', require: CaseStudies },
    { handle: '[data-footer]', require: Footer },
    { handle: '[data-footer-cta]', require: FooterCta },
    { handle: '[data-selector-image-gallery]', require: SelectorImageGallery },
    { handle: '[data-icon-cards-big]', require: IconCardsBig },
    { handle: '.comp-Offices', require: Offices },
    { handle: '[data-bio]', require: Bio },
    { handle: '[data-file-download]', require: FileDownload },

    { handle: '[data-inline-map]', require: InlineMap },
    { handle: '.comp-Directory', require: Directory },
    { handle: '.comp-DirectoryTwo', require: DirectoryTwo },
    { handle: '.job-listing', require: JobListing },
    { handle: '[data-overlay-dark]', require: OverlayDark },
    { handle: '[data-nav-selector]', require: NavSelector },
    { handle: '[data-components-stage]', require: ComponentsStage },
    { handle: '[data-filter-with-icons]', require: FilterWithIcons },
    { handle: '[data-filter-without-icons]', require: FilterWithoutIcons },
    { handle: '[data-alert]', require: Alert },
    { handle: '[data-global-alert]', require: GlobalAlert },
    { handle: '[data-timeline]', require: Timeline },
    { handle: '[data-selector]', require: Selector },
    { handle: '[data-form-basic]', require: FormBasic },
    { handle: '[data-form-full-width]', require: FormFullWidth },
    { handle: '[data-form-with-sidebar]', require: FormWithSidebar },
    { handle: '#gated-document-download', require: GatedDocument },
    { handle: '#content', require: GatedContent },
    { handle: '[data-submit-assignment]', require: SubmitAssignment },
    { handle: '[data-quote-cards]', require: QuoteCards },
    { handle: '[data-sharing]', require: Sharing },
    { handle: '[data-video-overlay]', require: VideoOverlay },
    { handle: '[data-directory-widget]', require: DirectoryWidget },
    { handle: '[data-insights-slider]', require: InsightsSlider },
    { handle: '[data-featured-events-slider]', require: FeaturedEventsSlider },
    { handle: '[data-insights-events-highlight-slider]', require: InsightsEventsHighlightSlider },
    { handle: '.comp-InsightListingsWithFilters', require: InsightListingsWithFilters },
    { handle: '.comp-EventListingsWithFilters', require: EventListingsWithFilters },
    { handle: '[data-slider]', require: KeyContactsSlider },
    {
      handle: '[data-language-selector-modal]',
      require: LanguageSelectorModal,
    },
    { handle: '[data-video-card]', require: VideoCard },
    { handle: '[data-video-modal]', require: VideoModal },
    {
      handle: '[data-expertise-listing-with-children]',
      require: ExpertiseListingWithChildren,
    },
    {
      handle: '[data-expertise-listing-with-callout]',
      require: ExpertiseListingWithCallout,
    },
    { handle: '[data-icon-card-big]', require: IconCardBig },
    { handle: '[data-icon-card]', require: IconCard },

    // form fields
    { handle: '[data-form-field-text]', require: FormFieldText },
    { handle: '.fui-type-single-line-text', require: FormFieldText },
    { handle: '[data-form-field-email]', require: FormFieldText },
    { handle: '.fui-type-email', require: FormFieldText },
    { handle: '[data-form-field-dropdown]', require: FormFieldDropdown },
    { handle: '.fui-type-dropdown', require: FormFieldDropdown },
    { handle: '[data-form-field-number]', require: FormFieldNumber },
    { handle: '.fui-type-number', require: FormFieldNumber },
    { handle: '[data-form-field-phone]', require: FormFieldPhone },
    { handle: '.fui-type-phone-number', require: FormFieldPhone },
    { handle: '[data-form-field-file-upload]', require: FormFieldFileUpload },
    { handle: 'select[data-country][autocomplete="country"]', require: FormFieldAddress },
    { handle: 'select[data-country]', require: FormFieldAddress },
  ];

  var sitewide = new Sitewide();
  sitewide.init();

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({ components: components });
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();

});
